import axios from './axios_'
import qs from 'qs'

let instance = axios()

export default {
    requestFormAjax({url, params, method, ourl}) {
        let fUrl = ourl + url
        if (method === 'get') {
            return instance.get(fUrl,{params},{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        } else if (method === 'post') {
            return instance.post(fUrl,qs.stringify(params),{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        }
    },
    requestAjax({url, params, method, ourl}) {
        let fUrl = ourl + url
        if (method === 'get') {
            return instance.get(fUrl,{params},{headers: {'Content-Type': 'application/json'}})
        } else if (method === 'post') {
            return instance.post(fUrl,params,{headers: {'Content-Type': 'application/json'}})
        }
    },
}